var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedHornAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 11,
    fill: "#FF6632",
    stroke: "#2F1C0A",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.0 , 9.0) scale(1.6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2936_25514)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7519 2.82909L16.8335 3.10892L16.9171 3.42631L16.9584 3.60003L17.042 3.97565L17.1218 4.39164L17.1979 4.84707C17.2223 5.00576 17.2448 5.17103 17.2674 5.34288L17.3284 5.88C17.4035 6.62278 17.4514 7.47636 17.4514 8.44451C17.4514 9.41265 17.4045 10.2662 17.3294 11.009L17.2674 11.5461C17.2458 11.718 17.2223 11.8842 17.1979 12.0419L17.1228 12.4974L17.042 12.9134L16.9584 13.289L16.8749 13.627L16.7922 13.9247L16.7519 14.0599C16.441 15.0807 15.3771 15.4732 14.5038 15.1821L13.3957 14.813L13.0201 15.6891C12.8346 16.1221 12.4933 16.4695 12.0637 16.6626C11.6341 16.8556 11.1476 16.8802 10.7007 16.7315L5.9154 15.1351C5.66909 15.053 5.44248 14.9206 5.24989 14.7465C5.05731 14.5723 4.90293 14.3601 4.79651 14.1233C4.69009 13.8864 4.63394 13.6301 4.6316 13.3704C4.62926 13.1108 4.68079 12.8535 4.78293 12.6148L5.03553 12.025L4.30496 11.7828L3.02036 12.211C2.73803 12.305 2.43739 12.3306 2.14322 12.2857C1.84905 12.2407 1.56977 12.1265 1.3284 11.9524C1.08703 11.7784 0.890479 11.5495 0.75494 11.2845C0.619401 11.0196 0.548757 10.7263 0.548828 10.4287V6.46127C0.548757 6.16368 0.619401 5.87034 0.75494 5.60542C0.890479 5.34049 1.08703 5.11157 1.3284 4.93751C1.56977 4.76345 1.84905 4.64924 2.14322 4.6043C2.43739 4.55935 2.73803 4.58494 3.02036 4.67898L4.30496 5.10718L14.5038 1.70788C15.3771 1.41678 16.441 1.80836 16.7519 2.82909ZM6.82345 12.6213L6.50887 13.3538L11.2942 14.9501L11.6088 14.2167L6.82345 12.6213ZM14.9987 3.52209L5.244 6.77396V10.115L14.9987 13.3669L15.071 13.1012L15.1461 12.7941L15.1837 12.6251L15.2569 12.2551C15.2813 12.1255 15.3048 11.9875 15.3283 11.8429L15.394 11.3874C15.4992 10.5921 15.5734 9.61548 15.5734 8.44451C15.5734 7.27447 15.4982 6.29694 15.3949 5.50157L15.3283 5.04614C15.3048 4.90153 15.2813 4.76443 15.2569 4.63297L15.1827 4.26393L15.1076 3.93621L14.9987 3.52209ZM2.42689 6.46127V10.4287L3.36593 10.115V6.77396L2.42689 6.46127Z",
    fill: "#2F1C0A",
    stroke: "#FF6632",
    strokeWidth: 0.583333
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_25514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2308,
    height: 17.2308,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHornAlert);
export default __webpack_public_path__ + "static/media/redHornAlert.2899d302e0f9e7623100e421ca1c4054.svg";
export { ForwardRef as ReactComponent };